import { ReactNode } from 'react';
import classnames from 'classnames';

type Orientation = 'row' | 'column';

const makeStyle = (orientation: Orientation, width?: number) =>
  orientation === 'row' && width ? { width: `${width}%` } : { flex: 1 };

interface Props {
  children: ReactNode;
  first?: boolean;
  last?: boolean;
  legend: boolean;
  orientation: Orientation;
  width?: number;
}

const RecordColumn = ({
  children,
  first,
  last,
  legend,
  orientation,
  width,
}: Props) => {
  const className = classnames({
    'items-center': true,
    'bg-record-background-color': true,
    'text-record-text-color': true,
    flex: true,
    'flex-row': true,
    'justify-center': true,
    'place-items-center': true,
    'last:!border-tr-none': true,
    'last:rounded-bl': true,
    'last:rounded-br': true,
    'border-t': orientation === 'column',
    'border-record-border-color': orientation === 'column',
    'p-2': orientation === 'column',
    'first:py-2': orientation === 'row',
    'first:!rounded-tl': (first && legend) || orientation === 'column',
    'first:!rounded-tr': orientation === 'column',
    'first:!rounded-bl': last && !legend && orientation === 'row',
    'last:!rounded-tr': last && legend,
    'last:!rounded-bl': (last && !legend) || orientation === 'column',
    'last:!rounded-br': (last && !legend) || orientation === 'column',
  });

  return (
    <li style={makeStyle(orientation, width)} className={className}>
      {children}
    </li>
  );
};

export default RecordColumn;
